import React, { useEffect, useState, memo } from 'react';
import { CheckCircle2, Loader2 } from 'lucide-react';
import { getContentLoadStatus } from '../../../../content';
/**
 * LoadedModulesWidget — Boot Flow Refactor diagnostics.
 *
 * Shows which of the 10 content modules are currently loaded into memory
 * and which are still pending. Polls every second so admins can watch
 * idle prefetch progress in real-time.
 */
export function LoadedModulesWidget() {
  const [status, setStatus] = useState(() => getContentLoadStatus());
  useEffect(() => {
    if (status.allLoaded) return;
    const id = window.setInterval(() => {
      const next = getContentLoadStatus();
      setStatus(next);
      if (next.allLoaded) window.clearInterval(id);
    }, 1000);
    return () => window.clearInterval(id);
  }, [status.allLoaded]);
  const {
    totalModules,
    loadedModuleCodes,
    pendingModuleCodes,
    allLoaded
  } = status;
  const loadedCount = loadedModuleCodes.length;
  const pct = Math.round(loadedCount / totalModules * 100);
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-5797">
      <div className="px-4 sm:px-5 py-4 border-b border-gray-100 bg-gray-50 flex items-center justify-between" data-id="element-5798">
        <div className="flex items-center gap-2" data-id="element-5799">
          <div className="w-4 h-4 text-gray-500" data-id="element-5800" />
          <h3 className="text-sm font-semibold text-gray-900" data-id="element-5801">
            Geladen modules
          </h3>
        </div>
        <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${allLoaded ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-700'}`} data-id="element-5802">
          {loadedCount} / {totalModules}
        </span>
      </div>
      <div className="p-4 sm:p-5 space-y-4" data-id="element-5803">
        <div data-id="element-5804">
          <div className="flex justify-between text-xs mb-1.5" data-id="element-5805">
            <span className="text-gray-700 font-medium" data-id="element-5806">Voortgang</span>
            <span className="font-semibold text-gray-600" data-id="element-5807">{pct}%</span>
          </div>
          <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-5808">
            <div className={`h-2 rounded-full transition-all ${allLoaded ? 'bg-emerald-500' : 'bg-indigo-500'}`} style={{
            width: `${pct}%`
          }} data-id="element-5809" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2" data-id="element-5810">
          {loadedModuleCodes.map(code => <div key={code} className="flex items-center gap-2 text-xs px-2.5 py-1.5 rounded-lg bg-emerald-50 text-emerald-800" data-id="element-5811">
              <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" data-id="element-5812" />
              <span className="font-mono font-medium" data-id="element-5813">{code}</span>
            </div>)}
          {pendingModuleCodes.map(code => <div key={code} className="flex items-center gap-2 text-xs px-2.5 py-1.5 rounded-lg bg-gray-50 text-gray-500" data-id="element-5814">
              <Loader2 className="w-3.5 h-3.5 flex-shrink-0 animate-spin" data-id="element-5815" />
              <span className="font-mono font-medium" data-id="element-5816">{code}</span>
            </div>)}
        </div>

        {!allLoaded && <p className="text-xs text-gray-500" data-id="element-5817">
            Idle prefetch is bezig op de achtergrond. Modules worden in-place
            aan de indexen toegevoegd zodra ze geladen zijn.
          </p>}
      </div>
    </div>;
}